import { render } from "./WarningModal.vue?vue&type=template&id=54510a7c"
import script from "./WarningModal.vue?vue&type=script&lang=js"
export * from "./WarningModal.vue?vue&type=script&lang=js"
script.render = render

export default script